// import AuthLayout from "../Layout/AuthLayout";
// import ForgotPassword from "../pages/Auth/ForgotPassword";
// import OTPverify from "../pages/Auth/OtpVerify";
// import ResetPassword from "../pages/Auth/ResetPassword";
import AuthLayout from "../Layout copy/AuthLayout";
import Login from "../pages/Login/Login2";

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  element: <AuthLayout />,
  children: [
    {
      path: "/",
      element: <Login />,
    },
    // {
    //   path: "/ForgetPassword",
    //   element: <ForgotPassword />,
    // },
    // {
    //   path: "/OTPverify",
    //   element: <OTPverify />,
    // },
    // {
    //   path: "/ResetPassword",
    //   element: <ResetPassword />,
    // },
  ],
};

export default LoginRoutes;
